import { render, staticRenderFns } from "./platformbar.vue?vue&type=template&id=1cce5ebe&"
import script from "./platformbar.vue?vue&type=script&lang=js&"
export * from "./platformbar.vue?vue&type=script&lang=js&"
import style0 from "./platformbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports